export default __webpack_public_path__ + "assets/media/guitar.eca586f7.png";